import BpkButton, {
  BUTTON_TYPES,
} from '@skyscanner-internal/backpack-web/bpk-component-button';
import BpkCard from '@skyscanner-internal/backpack-web/bpk-component-card';
import { withRtlSupport } from '@skyscanner-internal/backpack-web/bpk-component-icon';
import ArrowIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/long-arrow-right';
import BpkImage from '@skyscanner-internal/backpack-web/bpk-component-image';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';
import classNames from 'classnames';

import CustomSectionHeader from '../CustomSectionHeader';

import type { CtaCardSetProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/CtaCardSetProps';

import STYLES from './CtaCardSet.module.scss';

const RtlArrowIcon = withRtlSupport(ArrowIcon);

const CtaCardSet = ({ header, items, subheader }: CtaCardSetProps) => (
  <div className={STYLES.CtaCardSet}>
    <CustomSectionHeader header={header} subheader={subheader} />

    <div
      className={classNames([
        STYLES.CtaCardContainer,
        {
          [STYLES[`CtaCardContainer--with-margin-top`]]: header || subheader,
        },
      ])}
    >
      {items.map((item) => (
        <BpkCard padded={false} href={item.cta.href}>
          <div className={STYLES.CtaCard} data-testid="cta-card">
            <div className={STYLES.Image}>
              <BpkImage
                src={item.image.src}
                altText={item.image.altText || ''}
                aspectRatio={140 / 88}
              />
            </div>

            <div className={STYLES.Content}>
              <div>
                <BpkText tagName="h3" textStyle={TEXT_STYLES.heading4}>
                  {item.title}
                </BpkText>
                <BpkButton
                  type={BUTTON_TYPES.link}
                  href={item.cta.href}
                  implicit
                >
                  {item.cta.label} <RtlArrowIcon />
                </BpkButton>
              </div>
            </div>
          </div>
        </BpkCard>
      ))}
    </div>
  </div>
);

export default CtaCardSet;
